var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-wrapper"},[_c('UserProfile'),_c('UserDataInfo'),_c('NavList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }